import { BasePage } from '@Tenants/Hc/Site/BasePage';
import { BaseCouponsAndDiscounts, ICoupon } from '@Base/CouponsAndDiscounts/CouponsAndDiscounts';
import queryString from 'query-string';

import "./CouponsAndDiscounts.scss";

export class CouponsAndDiscounts extends BaseCouponsAndDiscounts
{
	constructor()
	{
		super();
	}

	public Initialize(): void
	{
		const parsed = queryString.parse(location.search);
		const simulateDateString = parsed.simulateDate as string;
		const simulateDate = new Date(simulateDateString);
		let currentDate: Date;
		let subscribeCoupon: ICoupon;

		if (simulateDate instanceof Date && !isNaN(simulateDate.getTime()))
		{
			currentDate = simulateDate;
		}
		else
		{
			currentDate = new Date();
		}

		this.SiteCoupons = [
			{
				Type: "military",
				MobileCreativeID: "143726",
				DesktopCreativeID: "143724",
				SignUpSource: "HCUSMilitary",
				ButtonSelector: ".military-js"
			},
			{
				Type: "student",
				MobileCreativeID: "143736",
				DesktopCreativeID: "143734",
				SignUpSource: "HCUSStudent",
				ButtonSelector: ".student-js"
			}
		]

		// Orange Tuesday 2026 Email Sign Up Ad
		if (new Date("09/07/2026") < currentDate && currentDate < new Date("09/09/2026"))
		{
			subscribeCoupon = {
				Type: "subscribe",
				MobileCreativeID: "1212903",
				DesktopCreativeID: "1212902",
				SignUpSource: "HCUSOrangeTuesday2026",
				ButtonSelector: ".subscribe-js"
			};
		}
		else
		{
			subscribeCoupon = {
				Type: "subscribe",
				MobileCreativeID: "1193593",
				DesktopCreativeID: "1193591",
				SignUpSource: "HCUSPopup15OffOne",
				ButtonSelector: ".subscribe-js"
			};
		}

		this.SiteCoupons.push(subscribeCoupon);

		super.Initialize();
	}
}

export class CouponsAndDiscountsPage extends BasePage
{
	public CouponsAndDiscounts: CouponsAndDiscounts;

	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
		this.CouponsAndDiscounts = new CouponsAndDiscounts();
	}
}

const couponsAndDiscounts = new CouponsAndDiscountsPage();